'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var BodyModel = require('src/common/page-model')

var ClientNodesList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      this.region = options.region
      this.client = options.client
    },
    listNodes: function () {
      var self = this
      // // this.container = options.container
      self.devices = App.globalChannel.request('device:entities', {
        queryParams: {
          client: self.client.get('_id')
        }
      })

      var bodyModel = new BodyModel({
        title: 'Nodes',
        buttons: [
          { label: 'add node', primary: true, slug: 'node', action: 'client-nodes:add', roles: ['super', 'admin'] }
        ]
      })

      self.layout = self.getLayoutView(bodyModel)
      self.listenTo(self.layout, 'client-nodes:add', self.onAdd)

      self.listenTo(self.layout, 'render', function () {
        self.listRegion(self.devices)
      })

      self.region.show(self.layout)
      // App.rootLayout.showChildView('mainRegion', self.layout)
      //
      //
    },
    listRegion: function (nodes, columns) {
      var self = this
      //
      var columns = {
        '_bulk': {
          'options': {
            'edit': {'label': 'Edit', 'roles': ['super', 'admin']},
            'delete': {'label': 'Delete', 'roles': ['super']}
          }
        },
        'name': {'label': 'name', 'sortable': true, 'roles': [] },
        'type': {'label': 'type', 'sortable': true, 'roles': []},
        'createdAt': {'label': 'created at', 'sortable': true, 'roles': [],  'hideSizes':['mobile'] },
        '_actions': {
          'options': {
            'edit': { 'action': 'edit', 'roles': [] },
            'manage': {'action': 'manage', 'roles': []}
          }
        }
      }

      //
      var emptyViewModel = new Backbone.Model({
        title: 'No nodes attached.',
        subTitle: 'add some nodes to get started'
      })

      //
      var layout = this.getListView(nodes, columns, emptyViewModel)

      self.listenTo(layout, 'listview:childview:item:edit', self.onEdit)
      self.listenTo(layout, 'listview:childview:item:manage', self.onManage)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      self.layout.getRegion('listRegion').show(layout)
    },

    onBulk: function (args) {
      switch (args.bulk_action) {
        case 'edit':
          App.globalChannel.trigger('device:edit', {region: App.rootLayout.getRegion('dialogRegion'), collection: args.collection, client: this.client, bulkAction: true})
          break
        case 'delete':
          App.dialog.confirm({
            message: 'Are you sure you want to peform a bulk delete?',
            callback: function (confirmed) {
              if (confirmed) {
                args.collection.bulkDelete({})
              }
            }
          })
          break
        default:
          console.warn('Bulk action not catched by switch, "' + args.bulk_action + '"')
          break
      }
    },
    onManage: function (args) {
      App.globalChannel.trigger('app:navigate', 'device/' + args.model.id, true)
    },
    onAdd: function (args) {
      App.globalChannel.trigger('device:new', {region: App.rootLayout.getRegion('dialogRegion'), client: this.client, collection: this.devices})
    },
    onShow: function (args) {
      App.globalChannel.trigger('client:show', {model: args.model})
    },
    onEdit: function (args) {
      App.globalChannel.trigger('device:edit', {region: App.rootLayout.getRegion('dialogRegion'), device: args.model})
      
     // App.globalChannel.trigger('client-nodes:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    },
    getListView: function (nodes, columns, emptyViewModel) {
      // create the listview based on the list component
      return new View.listView({
        collection: nodes,
        columns: columns,
        emptyViewModel: emptyViewModel,
        childView: View.listItem // use a custom childview
      })
    },
    getLayoutView: function (model) {
      return new View.layout({model: model})
    }
  })

  return new Controller(options)
}

module.exports = ClientNodesList



// WEBPACK FOOTER //
// ./js/modules/client-nodes/list/index.js